import axios from "axios";
import {liveURL,ApiKey } from "../constants/Consts";


// Base URL for theme configuration
const GET_THEME_CONFIG = `${liveURL}/websiteTheme/getThemeConfig`;
const UPDATE_THEME_CONFIG = `${liveURL}/websiteTheme/updateThemeConfig`;
const GET_SAVED_THEMES = `${liveURL}/websiteTheme/getSavedThemes`;
const SAVE_THEME = `${liveURL}/websiteTheme/saveTheme`;
const APPLY_THEME = `${liveURL}/websiteTheme/applyTheme`;
const DELETE_THEME = `${liveURL}/websiteTheme/deleteTheme`;

export const getThemeConfig = async (token) => {
    try {
        const response = await axios.get(GET_THEME_CONFIG, {
            headers: {
                apikey: ApiKey,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in getThemeConfig:", error);
        return { error: "Failed to fetch theme configuration", details: error.message };
    }
};

export const updateThemeConfig = async (themeData,token) => {
    try {
        const response = await axios.post(UPDATE_THEME_CONFIG, themeData, {
            headers: {
                apikey: ApiKey,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in updateThemeConfig:", error);
        return { error: "Failed to update theme configuration", details: error.message };
    }
};

export const getSavedThemes = async () => {
    try {
        const response = await axios.get(GET_SAVED_THEMES, {
            headers: {
                apikey: ApiKey,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in getSavedThemes:", error);
        return { error: "Failed to fetch saved themes", details: error.message };
    }
};

export const saveTheme = async (themeData) => {
    try {
        const response = await axios.post(SAVE_THEME, themeData, {
            headers: {
                apikey: ApiKey,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in saveTheme:", error);
        return { error: "Failed to save theme", details: error.message };
    }
};

export const applyTheme = async (themeId) => {
    try {
        const response = await axios.post(APPLY_THEME, { themeId }, {
            headers: {
                apikey: ApiKey,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in applyTheme:", error);
        return { error: "Failed to apply theme", details: error.message };
    }
};

export const deleteTheme = async (themeId) => {
    try {
        const response = await axios.delete(`${DELETE_THEME}/${themeId}`, {
            headers: {
                apikey: ApiKey,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in deleteTheme:", error);
        return { error: "Failed to delete theme", details: error.message };
    }
};